import Vue from 'vue'
import Router from 'vue-router'
import mainpage from '@/components/mainpage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/clients/metamarathon/',
    name: 'Metamarathon 2019',
    component: mainpage
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js